webpackJsonp([22846029969948],{

/***/ 1292:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PurchaseOrderStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CANCELLED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DRAFT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ORDERED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"PARTIAL"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"RECEIVED"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-purchase-order-status-60a1a400f06789c7b179.js